import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { FaChevronLeft } from 'react-icons/fa';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useHistory } from "react-router-dom";

import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay.js";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay";
// import DeleteOverlay from '../../../components/overlays/DeleteOverlay';
import AllRulesModal from "../../UserComponents/modals/AllRulesModal";
import UserSubscriptionsList from "../../UserComponents/modals/UserSubscriptions.js";
import { GetAllRulesAction } from "../../../redux/actions/gameRulesAction.js";
import { isValidEmail } from "../../utils/helper.js";
import {
  getUserSubscriptions,
  assignSubscription,
} from "../../services/user.services.js";
import {
  editTeam,
  getOneTeam,
  deleteTeam,
} from "../../services/team.services.js";
import {
  SELECTED_TEAM,
  UpdateSelectedTeam,
} from "../../../redux/actions/teamActions.js";
import "./EditTeam.css";
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";

const initialState = {
  teamId: "",
  teamName: "",
  teamNickName: "",
  teamColor: "",
  gameRules: "",
  coachName: "",
  coachCell: "",
  coachEmail: "",
};

const EditTeam = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);
  const operatorTeam = useSelector((state) => state.team.selectedTeam);

  const allRules = useSelector((state) => state.gameRules.allRules);

  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [groupModal, setGroupModal] = useState(false);
  const [selectedRule, setSelectedRule] = useState(null);
  const [displayPhone, setDisplayPhone] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [error, setError] = useState(null);
  const [getTeamLoading, setGetTeamLoading] = useState(false);
  const [updateTeamLoader, setUpdateTeamLoader] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [delSuccessVisible, setDelSuccessVisible] = useState(false);
  const [userSubsData, setUserSubsData] = useState(null);
  const [subsLoading, setSubsLoading] = useState(true);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [subscriptionVisible, setSubscriptionVisible] = useState(false);
  const toggleSubscriptions = () => setSubscriptionVisible(!subscriptionVisible);
  const userId = props.userId;

  const toggleDelete = () => {
    setDeleteVisible(!deleteVisible);
  };

  const toggleDelSuccessModal = () => {
    setDeleteVisible(false);
    setDelSuccessVisible(!delSuccessVisible);
    setTimeout(() => {
      history.push("/selectteam");
      setDelSuccessVisible(false);
    }, 2500);
  };

    useEffect(() => {
      const fetchSubscriptions = async () => {
        try {
          setSubsLoading(true); // start loading
          const response = await getUserSubscriptions(
            {
              userId: userId || user._id,
            },
            user?.token
          );
          setUserSubsData(response.data);
        } catch (error) {
          console.error("Error fetching user subscriptions:", error);
          setUserSubsData([]); // fallback to empty array
        } finally {
          setSubsLoading(false); // end loading
        }
      };
      fetchSubscriptions();
    }, [userId, user]);

  const toggleSuccessModal = () => {
    setSuccessVisible(!successVisible);
    setTimeout(() => {
      history.push("/myteam");
      setSuccessVisible(false);
    }, 2500);
  };

  const goBackHandler = () => {
    history.goBack();
  };

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const toggleGroupModal = () => {
    setGroupModal(!groupModal);
  };

  const handleSelectGroup = (val) => {
    setSelectedRule(val);
    handleFormChange("gameRules", val._id);
    setGroupModal(false);
  };

  // Fetch team data
  useEffect(() => {
    (async () => {
      try {
        setGetTeamLoading(true);
        let response = await getOneTeam(operatorTeam?.teamId._id, user?.token);
        handleFormChange("teamId", response.data._id);
        handleFormChange("teamName", response.data.teamName);
        handleFormChange("teamNickName", response.data.teamNickName);
        handleFormChange("teamColor", response.data.teamColor);
        handleFormChange("coachCell", response.data.coachCell);
        handleFormChange("coachEmail", response.data.coachEmail);
        handleFormChange("coachName", response.data.coachName);
        handleFormChange("gameRules", response.data.gameRules);
      } catch (e) {
        console.log("Err at getOneTeam", e);
      } finally {
        setGetTeamLoading(false);
      }
    })();
  }, [operatorTeam, user?.token]);

  // tid
  useEffect(() => {
    dispatch(GetAllRulesAction(user?.token));
    handleFormChange("teamId", operatorTeam?.teamId._id);
  }, [dispatch, user?.token, operatorTeam?.teamId._id]);
  // phoneLength
  useEffect(() => {
    let phoneLength = initialStateForm.coachCell.length;
    let formattedNumber = "";

    if (phoneLength < 4) {
      // return initialStateForm.phone;
      formattedNumber = initialStateForm.coachCell;
    } else {
      if (phoneLength > 3 && phoneLength < 7) {
        formattedNumber = `(${initialStateForm.coachCell
          .toString()
          .slice(0, 3)}) ${initialStateForm.coachCell.toString().slice(3)}`;
      } else {
        formattedNumber = `(${initialStateForm.coachCell
          .toString()
          .slice(0, 3)}) ${initialStateForm.coachCell
            .toString()
            .slice(3, 6)}-${initialStateForm.coachCell.toString().slice(6, 12)}`;
      }
    }

    setDisplayPhone(formattedNumber);
  }, [initialStateForm.coachCell]);

  const handleUpdate = async () => {
    let emailLength = initialStateForm.coachEmail.length;
    try {
      if (emailLength > 0 && !isValidEmail(initialStateForm.coachEmail)) {
        throw new Error("Invaid email format!");
      }
      setUpdateTeamLoader(true);
      const response = await editTeam(initialStateForm, user?.token);
      toggleSuccessModal();
      dispatch(UpdateSelectedTeam(operatorTeam?._id));
    } catch (e) {
      setError(e);
      console.log("Error at EDIT LICENSE team ===>", e.response.data);
    } finally {
      setUpdateTeamLoader(false);
    }
  };
  const handleDeleteTeam = async () => {
  const confirmDelete = window.confirm("Are you sure you want to delete this team? This action cannot be undone.");
  if (!confirmDelete) return; // stop if user cancels

  try {
    setLoading(true);
    const response = await deleteTeam(operatorTeam?.teamId._id, user?.token);
    toggleDelSuccessModal();
    dispatch({
      type: SELECTED_TEAM,
      payload: null,
    });
  } catch (e) {
    setError(e);
  } finally {
    setLoading(false);
  }
};


  const goBack = () => {
    history.goBack();
  };

  return (
    <div className="editTeam-container">
      <UserSidebar />
      {/* Error Overlay */}
      <ErrorOverlay
        onBackdropPress={() => setError(null)}
        visible={!!error}
        error={error}
      />

      <div className="editTeam-content">
        {/* Header */}
        <div className="editTeam-header">
          <h1 className="editTeam-title">Edit Team</h1>
          <button onClick={handleDeleteTeam} className="delete-btn">
            <DeleteOutlineIcon sx={{ fontSize: 28 }} />
          </button>
        </div>

        {/* Form */}
        <form className="editTeam-form">
          <div className="form-row">
            <div className="form-group">
              <label>Team Name:</label>
              <input
                placeholder="Team Name"
                value={initialStateForm.teamName}
                onChange={(e) => handleFormChange("teamName", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Team Nickname:</label>
              <input
                placeholder="Team Nickname"
                value={initialStateForm.teamNickName}
                onChange={(e) =>
                  handleFormChange("teamNickName", e.target.value)
                }
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Coach Name:</label>
              <input
                placeholder="Coach Name"
                value={initialStateForm.coachName}
                onChange={(e) => handleFormChange("coachName", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Coach Cell#:</label>
              <input
                placeholder="Coach contact number"
                value={isFocused ? initialStateForm.coachCell : displayPhone}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(e) => handleFormChange("coachCell", e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Coach Email:</label>
              <input
                placeholder="Coach email"
                value={initialStateForm.coachEmail}
                onChange={(e) => handleFormChange("coachEmail", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Game Rules:</label>
              <button
                type="button"
                onClick={toggleGroupModal}
                className="select-btn"
              >
                {selectedRule
                  ? selectedRule.ruleId
                  : operatorTeam?.teamId?.gameRules?.ruleId ||
                  "Select game rules"}
              </button>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group full-width">
              <label>Subscription:</label>
              <div
                className="subscription-box"
                onClick={toggleSubscriptions}
                style={{ cursor: "pointer" }} 
              >
                <span>
                  {operatorTeam?.subscriptionType?.subscriptionName}
                </span>
                <button
                  disabled={loading}
                  className="view-btn"
                  onClick={(e) => {
                    e.stopPropagation(); 
                    toggleSubscriptions();
                  }}
                >
                  VIEW
                </button>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="form-actions">
            <button
              type="button"
              onClick={goBackHandler}
              className="cancel-btn-editTeam"
            >
              Cancel
            </button>
            <button type="button" onClick={handleUpdate} className="save-btn-editTeam">
              {updateTeamLoader ? "Saving..." : "Save"}
            </button>
          </div>
        </form>

        <AllRulesModal
          data={allRules || []}
          setSelectedRule={handleSelectGroup}
          groupModal={groupModal}
          closeModal={() => setGroupModal(false)}
        />
        <UserSubscriptionsList
          data={userSubsData || []}
          loading={subsLoading}   // <-- add this
          setSelectedSubscription={setSelectedSubscription}
          visible={subscriptionVisible}
          onClose={toggleSubscriptions}
        />

        {successVisible && (
          <SuccessOverlay
            onBackdropPress={() => setSuccessVisible(false)}
            isVisible={successVisible}
            type="Team has been edited successfully!"
          />
        )}
      </div>
    </div>
  );
};
export default EditTeam;
